var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.75C6.61553 15.75 5.26216 15.3395 4.11101 14.5703C2.95987 13.8011 2.06266 12.7079 1.53285 11.4288C1.00303 10.1497 0.86441 8.74224 1.13451 7.38437C1.4046 6.0265 2.07129 4.77922 3.05026 3.80026C4.02922 2.82129 5.2765 2.1546 6.63437 1.88451C7.99224 1.61441 9.3997 1.75303 10.6788 2.28285C11.9579 2.81266 13.0511 3.70987 13.8203 4.86101C14.5895 6.01216 15 7.36553 15 8.75C15 10.6065 14.2625 12.387 12.9497 13.6997C11.637 15.0125 9.85652 15.75 8 15.75ZM8 2.75C6.81332 2.75 5.65328 3.1019 4.66658 3.76119C3.67989 4.42047 2.91085 5.35755 2.45673 6.4539C2.0026 7.55026 1.88378 8.75666 2.11529 9.92054C2.3468 11.0844 2.91825 12.1535 3.75736 12.9926C4.59648 13.8318 5.66558 14.4032 6.82946 14.6347C7.99335 14.8662 9.19975 14.7474 10.2961 14.2933C11.3925 13.8392 12.3295 13.0701 12.9888 12.0834C13.6481 11.0967 14 9.93669 14 8.75C14 7.1587 13.3679 5.63258 12.2426 4.50736C11.1174 3.38214 9.5913 2.75 8 2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.295 11.75L7.5 8.955V4.25H8.5V8.54L11 11.045L10.295 11.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic-clock.4f4b2fadbc375b3581c701fa5c6293ab.svg";
export { ForwardRef as ReactComponent };